import { render, staticRenderFns } from "./DeferredPayments.vue?vue&type=template&id=3b88a999"
import script from "./DeferredPayments.vue?vue&type=script&lang=js"
export * from "./DeferredPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports